import * as yup from "yup";

export const OperacionUnitariaSchema = yup.object().shape({
  orden: yup
    .number()
    .integer()
    .typeError("errors.operacionUnitaria.orden.type")
    .required("errors.operacionUnitaria.orden.required")
    .default(-1),
  nombre: yup
    .string()
    .uppercase()
    .max(100, "errors.operacionUnitaria.nombre.max")
    .required("errors.operacionUnitaria.nombre.required")
    .default(""),
  descripcion: yup
    .string()
    .uppercase()
    .max(1024, "errors.operacionUnitaria.descripcion.max")
    .required("errors.operacionUnitaria.descripcion.required")
    .default(""),
});
